import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@aaas/shared';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { useTranslation, Trans } from 'react-i18next';

interface PipelineChangeWarningDialogProps {
  open: boolean;
  cvCount: number;
  newPipelineName: string;
  firstRoundName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function PipelineChangeWarningDialog({
  open,
  cvCount,
  newPipelineName,
  firstRoundName,
  onConfirm,
  onCancel,
  isLoading = false,
}: PipelineChangeWarningDialogProps) {
  const { t } = useTranslation('ats');
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            {t('pipeline.changeWarning.title')}
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="text-left space-y-2">
              <p>
                <Trans
                  i18nKey="pipeline.changeWarning.intro"
                  ns="ats"
                  values={{ name: newPipelineName }}
                  components={{ strong: <strong className="text-foreground" /> }}
                />
              </p>
              <p>
                <Trans
                  i18nKey="pipeline.changeWarning.moveCvs"
                  ns="ats"
                  count={cvCount}
                  values={{ count: cvCount, round: firstRoundName }}
                  components={{ strong: <strong className="text-foreground" /> }}
                />
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} disabled={isLoading}>
            {t('pipeline.changeWarning.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                {t('pipeline.changeWarning.processing')}
              </>
            ) : (
              t('pipeline.changeWarning.confirm')
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
